import { render, staticRenderFns } from "./home.vue?vue&type=template&id=74c56454&scoped=true&"
import script from "./home.vue?vue&type=script&lang=js&"
export * from "./home.vue?vue&type=script&lang=js&"
import style0 from "./home.vue?vue&type=style&index=0&id=74c56454&prod&lang=less&"
import style1 from "./home.vue?vue&type=style&index=1&id=74c56454&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c56454",
  null
  
)

export default component.exports